var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customer-queue"
  }, [_c('div', {
    staticClass: "customer-queue-header"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.排队等待中")) + "... ")]), _c('div', {
    staticClass: "customer-queue-info"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.排队等待话术")) + " ")]), _c('div', {
    staticClass: "customer-queue-container"
  }, [_c('div', {
    staticClass: "customer-queue-content-title"
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.当前前方排队人数")) + " ")]), _c('div', {
    staticClass: "customer-queue-content-number"
  }, [_vm._v(" " + _vm._s(_vm.props.queueNumber) + " ")])]), _c('div', {
    staticClass: "customer-queue-end-button"
  }, [_c('div', {
    class: ['customer-queue-end-button-content', _vm.isClicked ? 'button-clicked' : ''],
    on: {
      "click": _vm.leaveQueue
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("AIDesk.结束排队")) + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }